import { StateCreator } from "zustand";

export interface ToggleSlice {
  greetingOpen: boolean;
  hasGreetingShown: boolean;
  openGreeting: () => void;
  closeGreeting: () => void;
  toggleGreeting: () => void;
  markGreetingShown: () => void;
  dismissGreeting: () => void;
}

export const createToggleSlice: StateCreator<
  ToggleSlice,
  [],
  [],
  ToggleSlice
> = (set) => ({
  greetingOpen: false,
  hasGreetingShown: false,
  openGreeting: () => set({ greetingOpen: true }),
  closeGreeting: () => set({ greetingOpen: false }),
  toggleGreeting: () => set((state) => ({ greetingOpen: !state.greetingOpen })),
  markGreetingShown: () => set({ hasGreetingShown: true }),
  dismissGreeting: () => set({ greetingOpen: false, hasGreetingShown: true }),
});
